import { Component, createRef } from "react";
import { connect } from "react-redux";
import {
  formatNumber,
  isCurrentRoute,
  navigateTo,
  showNotification,
  handleClickOutside,
  isDesktop,
  isMobile,
} from "../lib/helper";
import { withRouter } from "react-router-dom";
import {
  fetchingUser,
  fetchingUserSuccess,
  updateAppConfigAction,
  fetchingTransactionAction,
  fetchingNotification,
  closeBollinger,
} from "../redux/actions";
import api from "../lib/api";
import constants from "../lib/constants";
import Deposit from "./trading/partial/Deposit";
import Notification from "../lib/custom/Notification";
import i18n from "../i18n";
import { withTranslation } from "react-i18next";
import storage from "../lib/storage";
import { useSnackbar } from "notistack";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_show_dropdown: false,
      is_show_helper: false,
      is_show_setting: false,
      is_show_notification: false,
      enable_sound: 1,
      is_show_balance: 1,
      is_show_dd: false,
      locale: "",
    };

    this.refList = {
      is_show_dropdown: createRef(),
      is_show_helper: createRef(),
      is_show_setting: createRef(),
    };
  }

  componentDidMount() {
    let { enable_sound, is_show_balance } = this.props.memberReducer || {};
    let current_lang = i18n.language;
    this.setState({ locale: current_lang });
    this.setState({ enable_sound, is_show_balance });
    document.addEventListener("click", handleClickOutside.bind(this));
    this.props.fetchingNotification();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener("click", handleClickOutside.bind(this));
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    const header = document.querySelector(".headerWapper");
    if (this.props.memberReducer.login_token) {
      header.style.backgroundColor = "#181A20";
      return;
    }
    if (window.scrollY > 50) {
      header.style.backgroundColor = "#181A20";
      header.style.transition = "background-color 0.3s";
    } else {
      header.style.backgroundColor = "";
    }
  };
  toggleTransactionBox = (e) => {
    e.preventDefault();
    this.onChangeState("is_show_dropdown")();
    this.props.updateAppConfigAction({ is_show_transferbox: true });
  };
  onChangePointType = (point_type) => () => {
    const { enqueueSnackbar } = this.props;
    api
      .putChangeProfile({ current_point_type: point_type })
      .then(({ data, message, success }) => {
        if (success) {
          this.props.fetchingUserSuccess(data);
        } else {
          showNotification(enqueueSnackbar, { message: message, type: "danger" });
        }
      });
    this.onChangeState("is_show_dropdown")();
  };

  onResetDemoBalance = (e) => {
    const { enqueueSnackbar } = this.props;
    e.preventDefault();
    api.resetDemoBalance().then(({ data, success, message }) => {
      if (success) {
        this.props.fetchingUserSuccess(data);
      }
      showNotification(enqueueSnackbar, { message, type: success ? "success" : "danger" });
      this.onChangeState("is_show_dropdown")();
    });
  };

  onClickChangeSetting = (type) => () => {
    const { enqueueSnackbar } = this.props;
    let value = this.state[type] === 1 ? 0 : 1;
    this.setState({ [type]: value }, () => {
      api
        .putChangeProfile({ [type]: value })
        .then(({ data, success, message }) => {
          if (success) {
            showNotification(enqueueSnackbar, { message, type: success ? "success" : "danger" });
            return this.props.fetchingUserSuccess(data);
          }
        });
    });
  };
  onchangeLanguage = (lang) => (e) => {
    e.preventDefault();
    const { i18n } = this.props;
    i18n.changeLanguage(lang);
    this.setState({ locale: lang });
    storage.saveConfig({ locale: lang });
  };
  onToggle = (type) => (e) => {
    e.preventDefault();
    this.props.updateAppConfigAction({ [type]: !this.props.appReducer[type] });
    if (type === "is_show_transaction") {
      this.props.fetchingTransactionAction();
    }
  };

  onChangeState = (type) => (e) => {
    e && e.preventDefault();
    this.setState({ [type]: !this.state[type] });
  };

  onReadAllNotification = () => {
    api
      .putMarkReadAllNotification()
      .then(() => this.props.fetchingNotification());
  };
  showDD = (type) => (e) => {
    e.preventDefault();
    this.setState({ [type]: !this.state[type] });
  };
  onViewAllNotification = () => {
    this.setState({ is_show_notification: false });
    navigateTo("notification").bind(this)();
  };

  render() {
    let { login_token, demo_balance, real_balance, current_point_type, is_email_verified } =
      this.props.memberReducer || {};
    let balance = this.props.memberReducer[`${current_point_type}_balance`];
    let {
      is_show_dropdown,
      is_show_setting,
      enable_sound,
      is_show_balance,
      is_show_notification,
      is_show_dd,
      locale,
    } = this.state;
    let {
      prize_pool,
      is_show_menu,
    } = this.props.appReducer;
    let { un_read_count, notification } = this.props.notificationReducer;
    let { total_bet_open } = this.props.transactionReducer;
    let { t } = this.props;
    let { isBollingerClosed } = this.props.headerReducer;
    return (
      <div data-v-bd82969a="" data-v-b0e45e8c="" className="headerMaster">
        <div
          data-v-bd82969a=""
          className={`boxHeader navbar w-100 ${login_token && is_email_verified === 1 ? "" : "position-fixed"
            }`}
          style={{
            borderBottom: isCurrentRoute(constants.ROUTE.HOME) ? "none" : "",
            height: "65px",
          }}
        >
          <div
            data-v-bd82969a=""
            className={
              "headerWapper d-flex align-items-center position-fixed w-100 pr-2 pr-lg-4" +
              (isCurrentRoute(constants.ROUTE.HOME) ? "notAuthentication" : "")
            }
            style={{
              background: login_token && is_email_verified === 1 ? "#181a20" : "",
              borderBottom: login_token && is_email_verified === 1 ? "2px solid rgb(0, 0, 0)" : "",
            }}
          >
            <header
              data-v-bd82969a=""
              className="d-flex pl-lg-0 pl-2 justify-content-between align-items-center w-100"
              style={{ height: "65px" }}
            >
              <div
                data-v-bd82969a=""
                id="leftNav"
                className="d-flex align-items-center"
                style={{
                  height: isCurrentRoute(constants.ROUTE.HOME) ? "auto" : "",
                }}
              >
                {isMobile() && !isCurrentRoute(constants.ROUTE.HOME) && (
                  <div data-v-bd82969a="" className="mobile menuMobileIcon">
                    <span
                      data-v-bd82969a=""
                      onClick={this.onToggle("is_show_menu")}
                      className={
                        "mobileIcon " + (is_show_menu ? "show" : "hide")
                      }
                    >
                      <svg
                        data-v-bd82969a=""
                        xmlns="http://www.w3.org/2000/svg"
                        width="23.944"
                        height="19.953"
                        viewBox="0 0 23.944 19.953"
                      >
                        <g
                          data-v-bd82969a=""
                          id="menu-4"
                          transform="translate(0 -1)"
                        >
                          <path
                            data-v-bd82969a=""
                            id="Path_29261"
                            data-name="Path 29261"
                            d="M21.949,5H2A2,2,0,0,0,2,8.991H21.949a2,2,0,1,0,0-3.991Z"
                            transform="translate(0 3.981)"
                            fill="#fff"
                          />{" "}
                          <path
                            data-v-bd82969a=""
                            id="Path_29262"
                            data-name="Path 29262"
                            d="M21.949,1H2A2,2,0,0,0,2,4.991H21.949a2,2,0,1,0,0-3.991Z"
                            fill="#fff"
                          />{" "}
                          <path
                            data-v-bd82969a=""
                            id="Path_29263"
                            data-name="Path 29263"
                            d="M9.977,9H2a2,2,0,0,0,0,3.991H9.977A2,2,0,1,0,9.977,9Z"
                            transform="translate(0 7.963)"
                            fill="#fff"
                          />
                        </g>
                      </svg>
                    </span>
                  </div>
                )}
                <a
                  data-v-bd82969a=""
                  style={{ maxHeight: "65px" }}
                  href="#"
                  onClick={navigateTo().bind(this)}
                  className="d-flex align-items-center justify-content-center logoMobile router-link-exact-active router-link-active"
                >
                  {(isCurrentRoute(constants.ROUTE.HOME) || isDesktop()) && (
                    <img
                      data-v-bd82969a=""
                      style={{
                        objectFit: isDesktop() ? "cover" : "",
                        height: isDesktop() ? "65px" : "150px",
                      }}
                      width={isDesktop() ? "208px" : "150px"}
                      src="/images/logo-main.png?ver=1182835"
                      alt=""
                    />
                  )}
                </a>
                {/* {isMobile() && !isCurrentRoute(constants.ROUTE.HOME) && <Deposit />} */}
              </div>
              <div data-v-bd82969a="" id="rightNav">
                {login_token && is_email_verified === 1 ? (
                  isCurrentRoute(constants.ROUTE.HOME) ? (
                    <div
                      data-v-bd82969a=""
                      className={
                        "d-flex align-items-center pr-2 " +
                        (isDesktop() ? "" : "groupAuthentication")
                      }
                    >
                      <a
                        data-v-bd82969a=""
                        href="#"
                        onClick={navigateTo("trading").bind(this)}
                        className="btnheader w-130px log-in d-flex justify-content-center align-items-center"
                      >
                        <span
                          data-v-bd82969a=""
                          className={
                            "font-18 text-capitalize " +
                            (isDesktop() ? "" : "font-14m")
                          }
                        >
                          {t("Trade")}
                        </span>
                      </a>
                    </div>
                  ) : (
                    <ul
                      data-v-bd82969a=""
                      className="nav infoMem align-items-center"
                    >
                      <li
                        data-v-bd82969a=""
                        style={{ cursor: "pointer" }}
                        onClick={navigateTo("streak-challenge").bind(this)}
                        className="winStreak px-2"
                      >
                        <a className="block nav-link p-0"></a>
                        <div className="nav-streak-reward d-flex flex-column">
                          <span className="nav-streak-reward-lable font-9-sm block">
                            Prize Pool
                          </span>
                          <span className="nav-streak-reward-value font-12-sm block">
                            {`$${formatNumber(prize_pool)}K`}
                          </span>
                        </div>
                      </li>
                      <li
                        data-v-bd82969a=""
                        className="balance"
                        ref={this.refList.is_show_dropdown}
                      >
                        <div
                          data-v-bd82969a=""
                          className={
                            "dropdown pointer px-3 " +
                            (is_show_dropdown ? "show" : "")
                          }
                        >
                          <a
                            data-v-bd82969a=""
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded={is_show_dropdown}
                            onClick={this.onChangeState("is_show_dropdown")}
                            className="buttonBalance d-flex align-items-center"
                          >
                            <div
                              data-v-bd82969a=""
                              className="d-flex flex-column mr-lg-2 mr-2"
                            >
                              <span
                                data-v-bd82969a=""
                                className="font-lg-12 font-9-sm text-left color-white mb-1"
                              >{`${current_point_type === "demo"
                                ? t("DemoAccount")
                                : t("RealAccount")
                                }`}</span>
                              <div
                                data-v-bd82969a=""
                                className="d-flex align-items-center"
                              >
                                <span
                                  data-v-bd82969a=""
                                  className="colorWhite font-lg-18 font-12-sm"
                                >
                                  <b data-v-bd82969a="">
                                    ${formatNumber(balance)}
                                  </b>
                                </span>
                              </div>
                            </div>
                            <span data-v-bd82969a="" className="arrow">
                              <svg
                                data-v-bd82969a=""
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                viewBox="0 0 32 32"
                              >
                                <g
                                  data-v-bd82969a=""
                                  strokeLinecap="square"
                                  strokeLinejoin="miter"
                                  strokeWidth="2"
                                  fill="#111111"
                                  stroke="#111111"
                                  className="nc-icon-wrapper"
                                >
                                  <g
                                    data-v-bd82969a=""
                                    className="nc-interact_sorting-o-32"
                                  >
                                    <path
                                      data-v-bd82969a=""
                                      data-cap="none"
                                      fill="none"
                                      stroke="#ffffff"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M4 10l12 12"
                                      strokeDasharray="16.97 16.97"
                                      strokeDashoffset="0"
                                    />{" "}
                                    <path
                                      data-v-bd82969a=""
                                      data-cap="none"
                                      fill="none"
                                      stroke="#ffffff"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M28 10L16 22"
                                      strokeDasharray="16.97 16.97"
                                      strokeDashoffset="0"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </span>
                          </a>
                          <div
                            data-v-bd82969a=""
                            className={
                              "dropdown-menu sub-menu " +
                              (is_show_dropdown ? "show" : "")
                            }
                          >
                            <div
                              data-v-bd82969a=""
                              className="boxItemRadio pointer"
                            >
                              <div
                                data-v-bd82969a=""
                                className="d-flex align-items-center"
                              >
                                <div data-v-bd82969a="" className="flexLeft">
                                  <div
                                    data-v-bd82969a=""
                                    onClick={this.onChangePointType("real")}
                                    className="boxSelectAccount d-flex"
                                  >
                                    <span
                                      data-v-bd82969a=""
                                      className={
                                        "radioButton mr-2 " +
                                        (current_point_type === "real"
                                          ? "active"
                                          : "")
                                      }
                                    />
                                    <div data-v-bd82969a="">
                                      <div
                                        data-v-bd82969a=""
                                        className="d-flex flex-column"
                                      >
                                        <span
                                          data-v-bd82969a=""
                                          className="color-white-50 font-12 font-10m mb-1"
                                        >
                                          {t("RealAccount")}
                                        </span>
                                        <div
                                          data-v-bd82969a=""
                                          className="d-flex align-items-center"
                                        >
                                          <span
                                            data-v-bd82969a=""
                                            className="font-18 font-12m font-weight-700 price color-white d-flex"
                                          >
                                            <span data-v-bd82969a="">
                                              ${formatNumber(real_balance)}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-v-bd82969a=""
                                  className="flexRight d-flex justify-content-end align-items-center"
                                >
                                  <a
                                    data-v-bd82969a=""
                                    onClick={this.toggleTransactionBox}
                                    className="buttonDeposit font-12 font-10m"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="#3dc99f"
                                      width="46"
                                      height="29"
                                      viewBox="0 0 46 29"
                                      className="fill-light cursor-pointer undefined"
                                      role="none"
                                    >
                                      <g
                                        id="Group_13378"
                                        data-name="Group 13378"
                                        transform="translate(-230 -71)"
                                        role="none"
                                      >
                                        <g
                                          id="Group_13375"
                                          data-name="Group 13375"
                                          role="none"
                                        >
                                          <g
                                            id="Group_13376"
                                            data-name="Group 13376"
                                            role="none"
                                          >
                                            <rect
                                              id="Rectangle_4298"
                                              data-name="Rectangle 4298"
                                              width="46"
                                              height="29"
                                              rx="4"
                                              transform="translate(230 71)"
                                              className="fill-primary"
                                              role="none"
                                            ></rect>
                                          </g>
                                        </g>
                                        <g
                                          id="Group_13377"
                                          data-name="Group 13377"
                                          role="none"
                                        >
                                          <g
                                            id="conversion"
                                            transform="translate(246.725 78.133)"
                                            role="none"
                                          >
                                            <path
                                              id="Path_13963"
                                              fill="#fff"
                                              data-name="Path 13963"
                                              d="M15.692,7.459H1V6.123H14.079L10.072,2.116l.945-.944,5.147,5.147a.668.668,0,0,1-.472,1.14Z"
                                              transform="translate(-1 -1.172)"
                                              stroke="#fff"
                                              className="fill-color"
                                              role="none"
                                            ></path>
                                            <path
                                              id="Path_13964"
                                              fill="#fff"
                                              data-name="Path 13964"
                                              d="M6.342,34.287,1.2,29.14A.668.668,0,0,1,1.668,28H16.359v1.336H3.28l4.007,4.007Z"
                                              transform="translate(-1 -19.042)"
                                              stroke="#fff"
                                              className="fill-color"
                                              role="none"
                                            ></path>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-v-bd82969a=""
                              className="boxItemRadio pointer"
                            >
                              <div
                                data-v-bd82969a=""
                                className="d-flex align-items-center"
                              >
                                <div data-v-bd82969a="" className="flexLeft">
                                  <div
                                    data-v-bd82969a=""
                                    onClick={this.onChangePointType("demo")}
                                    className="boxSelectAccount d-flex"
                                  >
                                    <span
                                      data-v-bd82969a=""
                                      className={
                                        "radioButton mr-2 " +
                                        (current_point_type === "demo"
                                          ? "active"
                                          : "")
                                      }
                                    />
                                    <div data-v-bd82969a="">
                                      <div
                                        data-v-bd82969a=""
                                        className="d-flex flex-column"
                                      >
                                        <span
                                          data-v-bd82969a=""
                                          className="color-white-50 font-12 font-10m mb-1"
                                        >
                                          {t("DemoAccount")}
                                        </span>
                                        <div
                                          data-v-bd82969a=""
                                          className="d-flex align-items-center"
                                        >
                                          <span
                                            data-v-bd82969a=""
                                            className="font-18 font-12m font-weight-700 price color-white d-flex"
                                          >
                                            <span data-v-bd82969a="">
                                              ${formatNumber(demo_balance)}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-v-bd82969a=""
                                  className="flexRight d-flex justify-content-end align-items-center"
                                >
                                  <a
                                    data-v-bd82969a=""
                                    onClick={this.onResetDemoBalance}
                                    href="#"
                                  >
                                    <img
                                      data-v-bd82969a=""
                                      width="19"
                                      height="19"
                                      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy43OTUiIGhlaWdodD0iMTguNDg4IiB2aWV3Qm94PSIwIDAgMTcuNzk1IDE4LjQ4OCI+CiAgPGcgaWQ9InJlZnJlc2gtMDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIDAuMDgxKSI+CiAgICA8cGF0aCBpZD0iUGF0aF8yNjI1OSIgZGF0YS1uYW1lPSJQYXRoIDI2MjU5IiBkPSJNMTguOCw3LjM2NiwxNy41NTUtLjA4MSwxNC45OTMsMi40ODFhOC44LDguOCwwLDEsMCwyLjksMTAuNjQxLjguOCwwLDAsMC0xLjQ2OC0uNjQyLDcuMjE1LDcuMjE1LDAsMSwxLTIuNTczLTguODU0bC0yLjUsMi41WiIgZmlsbD0iI2ZmZiIvPgogIDwvZz4KPC9zdmc+Cg=="
                                      alt=""
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      {isDesktop() && <Deposit />}
                      {isDesktop() && (
                        <>
                          {/* <li data-v-bd82969a="" className="settings">
													<a data-v-bd82969a=""
														href="#"
														onClick={navigateTo('dashboard').bind(this)}
														className={setClassNameCondition(isCurrentRoute(constants.ROUTE.DASHBOARD), 'router-link-exact-active active', '', 'nav-link p-0')}
														title="Bảng điều khiển">
														<div data-v-bd82969a="" className="buttonSetting d-block align-items-center pointer pc">
															<span data-v-bd82969a="" className="icon">
																<svg data-v-bd82969a=""
																	id="speedometer"
																	xmlns="http://www.w3.org/2000/svg"
																	width="17.809"
																	height="17.809"
																	viewBox="0 0 17.809 17.809"
																	className={isCurrentRoute(constants.ROUTE.DASHBOARD) ? 'active' : 'non-active'}><path
																		data-v-bd82969a="" id="Path_30761" data-name="Path 30761"
																		d="M9.995,9.995a2.226,2.226,0,0,0,0-3.149C9.125,5.978,1,1,1,1S5.978,9.125,6.846,9.995A2.226,2.226,0,0,0,9.995,9.995Z"
																		transform="translate(0.484 0.484)" fill={isCurrentRoute(constants.ROUTE.DASHBOARD) ? '#2076fe' : '#89809f'} /> <path
																		data-v-bd82969a="" id="Path_30762" data-name="Path 30762"
																		d="M8.9,0a1.484,1.484,0,1,0,0,2.968A5.936,5.936,0,1,1,2.968,8.9,1.484,1.484,0,1,0,0,8.9,8.9,8.9,0,1,0,8.9,0Z"
																		fill={isCurrentRoute(constants.ROUTE.DASHBOARD) ? '#2076fe' : '#89809f'} /></svg>
															</span>
															<span data-v-bd82969a="" className="font-14 txtProfile">Bảng điều khiển</span>
														</div>
													</a>
												</li> */}
                          <li
                            data-v-bd82969a=""
                            ref={this.refList.is_show_setting}
                            className="settings"
                          >
                            <div
                              data-v-bd82969a=""
                              onClick={this.onChangeState("is_show_setting")}
                              className="buttonSetting d-block align-items-center pointer pc"
                            >
                              <span data-v-bd82969a="" className="icon">
                                <svg
                                  data-v-bd82969a=""
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="17.281"
                                  height="17.283"
                                  viewBox="0 0 17.281 17.283"
                                >
                                  <g
                                    data-v-bd82969a=""
                                    id="gear"
                                    transform="translate(-2.004 -1.995)"
                                  >
                                    <path
                                      data-v-bd82969a=""
                                      id="Path_30727"
                                      data-name="Path 30727"
                                      d="M18.111,9.362,16.772,9.25a6.245,6.245,0,0,0-.814-1.96l.871-1.03a1.28,1.28,0,0,0-1.8-1.8L14,5.326a6.234,6.234,0,0,0-1.963-.816L11.92,3.17a1.28,1.28,0,0,0-2.552,0L9.256,4.51a6.245,6.245,0,0,0-1.96.814l-1.03-.868a1.28,1.28,0,0,0-1.8,1.8l.871,1.029a6.239,6.239,0,0,0-.816,1.961l-1.341.112a1.281,1.281,0,0,0,0,2.552l1.341.112a6.238,6.238,0,0,0,.814,1.96l-.871,1.03a1.28,1.28,0,0,0,1.8,1.8L7.3,15.95a6.239,6.239,0,0,0,1.961.816l.112,1.341a1.281,1.281,0,0,0,2.552,0l.112-1.341a6.238,6.238,0,0,0,1.96-.814l1.03.871a1.28,1.28,0,0,0,1.8-1.8l-.871-1.029a6.233,6.233,0,0,0,.816-1.961l1.341-.112a1.281,1.281,0,0,0,0-2.552Zm-7.467,4.445a3.168,3.168,0,1,1,3.168-3.168A3.168,3.168,0,0,1,10.644,13.806Z"
                                      fill="#fff"
                                    />
                                  </g>
                                </svg>
                              </span>{" "}
                              <span data-v-bd82969a="">{t("Settings")}</span>
                            </div>
                            {is_show_setting && (
                              <div data-v-c80df956="" data-v-bd82969a="">
                                <div data-v-c80df956="" className="settings">
                                  <div
                                    data-v-c80df956=""
                                    className="dropdown-menu dropdownSetting d-flex flex-column show"
                                  >
                                    <div data-v-c80df956="" className="wrap">
                                      <div className="pt-4 border-b border-light/10 p-[15px] d-flex align-items-center mb-3">
                                        <div className="pb-3 text-[15px] flex-1 d-flex align-self-end align-items-center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={19}
                                            height={19}
                                            className="mr-[5px]"
                                          >
                                            <g
                                              fill="none"
                                              stroke="#fff"
                                              strokeMiterlimit={10}
                                              opacity={0.5}
                                              transform="translate(-.324 -.324)"
                                            >
                                              <path
                                                d="M9.824.824v18"
                                                data-name="Line 1450"
                                              />
                                              <path
                                                d="M.824 9.824h18"
                                                data-name="Line 1451"
                                              />
                                              <ellipse
                                                cx={5.042}
                                                cy={8.824}
                                                strokeLinecap="square"
                                                data-name="Ellipse 1795"
                                                rx={5.042}
                                                ry={8.824}
                                                transform="translate(4.782 1)"
                                              />
                                              <path
                                                d="M2.359 5.118H17.29"
                                                data-name="Line 1452"
                                              />
                                              <path
                                                d="M2.359 14.53H17.29"
                                                data-name="Line 1453"
                                              />
                                              <circle
                                                cx={9}
                                                cy={9}
                                                r={9}
                                                strokeLinecap="square"
                                                data-name="Ellipse 1796"
                                                transform="translate(.824 .824)"
                                              />
                                            </g>
                                          </svg>
                                          <span className="align-middle text-light">
                                            {t("Lang")}
                                          </span>
                                        </div>
                                        <div className="flex-[.05] basis-[135px] justify-content-end">
                                          <div
                                            onClick={this.showDD("is_show_dd")}
                                            className="dropdown position-relative z-[2000]"
                                          >
                                            <a
                                              className="dropdown-toggle pointer d-flex align-items-center gap-x-2 font-normal min-w-[160px] min-h-[45px] px-3 py-[0.375rem] rounded-[0.125rem] bg-secondary-400 text-light text-sm"
                                              aria-haspopup="menu"
                                              id="headlessui-menu-button-:rg:"
                                              aria-expanded
                                              data-headlessui-state
                                              aria-controls="headlessui-menu-items-:r15:"
                                            >
                                              <img
                                                src={`/images/${i18n.language}.png`}
                                                width={24}
                                                height={18}
                                                role="none"
                                              ></img>
                                              <span className="flex-1 text-left">
                                                {locale}
                                              </span>
                                            </a>
                                            {is_show_dd && (
                                              <div>
                                                <div
                                                  className="position-absolute d-flex flex-column pointer"
                                                  aria-labelledby="headlessui-menu-button-:rg:"
                                                  id="headlessui-menu-items-:rr:"
                                                  role="menu"
                                                  tabIndex={0}
                                                  data-headlessui-state="open"
                                                >
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "en"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={-1}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/en.png"
                                                        alt="English"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        English
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "vi"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={-1}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/vi.png"
                                                        alt="English"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        Tiếng Việt
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "ja"
                                                    )}
                                                    className="rounded-sm z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={0}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/ja.png"
                                                        alt="日本"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        日本
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "ko"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={1}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/ko.png"
                                                        alt="한국어"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        한국어
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "zh"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={2}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/zh.png"
                                                        alt="中国"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        中国
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "km"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={3}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/km.png"
                                                        alt="ប្រទេសកម្ពុជា"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        ប្រទេសកម្ពុជា
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "th"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={4}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/th.png"
                                                        alt="Thai"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        Thai
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "id"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={5}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/id.png"
                                                        alt="Indonesian"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        Indonesian
                                                      </span>
                                                    </a>
                                                  </div>
                                                  <div
                                                    onClick={this.onchangeLanguage(
                                                      "lo"
                                                    )}
                                                    className="rounded-sm  z-[2000] bg-secondary-400 translate-y-1 text-sm text-light"
                                                  >
                                                    <a
                                                      tabIndex={6}
                                                      id="headlessui-menu-item-:rs:"
                                                      role="menuitem"
                                                      data-headlessui-state
                                                      className="dropdown-item d-flex align-items-center gap-x-2 border-t border-t-light-50/10 min-w-[160px] min-h-[45px] px-3 py-[0.375rem]"
                                                    >
                                                      <img
                                                        src="/images/lo.png"
                                                        alt="Lao"
                                                        width={24}
                                                        height={18}
                                                        role="none"
                                                      ></img>
                                                      <span className="flex-1 text-left">
                                                        Lao
                                                      </span>
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        data-v-c80df956=""
                                        className="line mb-3"
                                      >
                                        <div
                                          data-v-c80df956=""
                                          className="type"
                                        >
                                          <svg
                                            data-v-c80df956=""
                                            version="1.1"
                                            width="19"
                                            height="19"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 19 19"
                                            xmlSpace="preserve"
                                          >
                                            <g
                                              data-v-c80df956=""
                                              id="sound"
                                              transform="translate(0.5 -0.5)"
                                            >
                                              <g
                                                data-v-c80df956=""
                                                id="Path_30736"
                                                fill="#887F9E"
                                              >
                                                <path
                                                  data-v-c80df956=""
                                                  d="M13.7,19.3c-0.2,0-0.4-0.1-0.6-0.2l-6.9-4.6H0.5c-0.6,0-1-0.4-1-1V6.3c0-0.6,0.4-1,1-1h5.7l6.9-4.6
													c0.3-0.2,0.7-0.2,1,0c0.3,0.2,0.5,0.5,0.5,0.9v16.8c0,0.4-0.2,0.7-0.5,0.9C14,19.3,13.9,19.3,13.7,19.3z M1.5,12.5h5
													c0.2,0,0.4,0.1,0.6,0.2l5.6,3.8V3.4L7.1,7.1C6.9,7.2,6.7,7.3,6.5,7.3h-5V12.5z"
                                                  className="st0"
                                                />
                                              </g>{" "}
                                              <g
                                                data-v-c80df956=""
                                                id="Path_30737"
                                                fill="#887F9E"
                                              >
                                                <path
                                                  data-v-c80df956=""
                                                  d="M16.8,15.1c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4c0,0,0,0,0,0c1.9-2,1.9-5.1-0.1-7
													c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0c2.8,2.7,2.8,7.1,0.1,9.9c0,0-0.1,0.1-0.1,0.1C17.2,15,17,15.1,16.8,15.1z"
                                                  className="st0"
                                                />
                                              </g>
                                            </g>
                                          </svg>
                                          <span
                                            data-v-c80df956=""
                                            className="colorWhite"
                                          >
                                            {t("Sound")}
                                          </span>
                                        </div>
                                        <div
                                          data-v-c80df956=""
                                          className="control"
                                        >
                                          <div
                                            data-v-272fdeda=""
                                            data-v-c80df956=""
                                            className="toggleButtonWrapper"
                                          >
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              Off
                                            </span>
                                            <div
                                              data-v-272fdeda=""
                                              onClick={this.onClickChangeSetting(
                                                "enable_sound"
                                              )}
                                              className={
                                                "toggleButton pointer isButtonOnOff " +
                                                (enable_sound ? "hasBg" : "")
                                              }
                                            >
                                              <div
                                                data-v-272fdeda=""
                                                className={
                                                  "status " +
                                                  (enable_sound ? "yes" : "")
                                                }
                                              />
                                            </div>
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              On
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div data-v-c80df956="" className="line">
                                        <div
                                          data-v-c80df956=""
                                          className="type"
                                        >
                                          <svg
                                            data-v-c80df956=""
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="13.543"
                                            viewBox="0 0 18 13.543"
                                          >
                                            <g
                                              data-v-c80df956=""
                                              id="preview"
                                              transform="translate(-734.025 -2)"
                                              opacity="0.5"
                                            >
                                              <path
                                                data-v-c80df956=""
                                                id="Path_30402"
                                                data-name="Path 30402"
                                                d="M9.025,15.543c4.063,0,7.223-3.5,8.577-5.53a2.2,2.2,0,0,0,0-2.6C16.248,5.5,13.088,2,9.025,2S1.8,5.5.448,7.53a2.031,2.031,0,0,0,0,2.483C1.8,12.044,4.962,15.543,9.025,15.543Zm0-10.157a3.325,3.325,0,0,1,3.386,3.386,3.325,3.325,0,0,1-3.386,3.386A3.325,3.325,0,0,1,5.64,8.771,3.325,3.325,0,0,1,9.025,5.386Z"
                                                transform="translate(734)"
                                                fill="#fff"
                                              />
                                            </g>
                                          </svg>
                                          <span
                                            data-v-c80df956=""
                                            className="colorWhite"
                                          >
                                            {t("showBalance")}
                                          </span>
                                        </div>
                                        <div
                                          data-v-c80df956=""
                                          className="control"
                                        >
                                          <div
                                            data-v-272fdeda=""
                                            data-v-c80df956=""
                                            className="toggleButtonWrapper"
                                          >
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              Off
                                            </span>
                                            <div
                                              data-v-272fdeda=""
                                              onClick={this.onClickChangeSetting(
                                                "is_show_balance"
                                              )}
                                              className={
                                                "toggleButton pointer isButtonOnOff " +
                                                (is_show_balance ? "hasBg" : "")
                                              }
                                            >
                                              <div
                                                data-v-272fdeda=""
                                                className={
                                                  "status " +
                                                  (is_show_balance ? "yes" : "")
                                                }
                                              />
                                            </div>
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              On
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div data-v-c80df956="" className="line">
                                        <div
                                          data-v-c80df956=""
                                          className="type"
                                        >
                                          <svg
                                            className="mr-2"
                                            width={20}
                                            height={20}
                                            fill="#8c8d90"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                          >
                                            <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm96 288l288 0c17.7 0 32-14.3 32-32l0-68.2c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1l0 84c0 17.7 14.3 32 32 32z" />
                                          </svg>
                                          <span
                                            data-v-c80df956=""
                                            className="colorWhite"
                                          >
                                            {t("ShowBollinger")}
                                          </span>
                                        </div>
                                        <div
                                          data-v-c80df956=""
                                          className="control"
                                        >
                                          <div
                                            data-v-272fdeda=""
                                            data-v-c80df956=""
                                            className="toggleButtonWrapper"
                                          >
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              Off
                                            </span>
                                            <div
                                              data-v-272fdeda=""
                                              onClick={
                                                this.props.closeBollinger
                                              }
                                              className={
                                                "toggleButton pointer isButtonOnOff " +
                                                (isBollingerClosed
                                                  ? "hasBg"
                                                  : "")
                                              }
                                            >
                                              <div
                                                data-v-272fdeda=""
                                                className={
                                                  "status " +
                                                  (isBollingerClosed
                                                    ? "yes"
                                                    : "")
                                                }
                                              />
                                            </div>
                                            <span
                                              data-v-272fdeda=""
                                              className="colorWhite"
                                            >
                                              On
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </li>
                          <li data-v-bd82969a="" className="settings">
                            <a
                              data-v-bd82969a=""
                              href="#"
                              onClick={navigateTo("profile").bind(this)}
                              className="nav-link p-0"
                              id="profileLink"
                              title="Administrators"
                            >
                              <div
                                data-v-bd82969a=""
                                className="buttonSetting align-items-center pointer pc"
                              >
                                <span data-v-bd82969a="" className="icon">
                                  <svg
                                    data-v-bd82969a=""
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18.281"
                                    height="17.283"
                                    viewBox="0 0 24 24"
                                  >
                                    <g
                                      data-v-bd82969a=""
                                      id="circle-10"
                                      transform="translate(-1.164 -1.164)"
                                    >
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29003"
                                        data-name="Path 29003"
                                        d="M33.642,36.066V35.3a3.093,3.093,0,0,0-1.558-2.685l-3.078-1.765"
                                        transform="translate(-13.086 -13.978)"
                                        fill="#fff"
                                        stroke="#fff"
                                        strokeMiterlimit="10"
                                        strokeWidth="2"
                                      />{" "}
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29004"
                                        data-name="Path 29004"
                                        d="M14.636,30.847l-3.078,1.765A3.093,3.093,0,0,0,10,35.3v.768"
                                        transform="translate(-3.876 -13.978)"
                                        fill="#fff"
                                        stroke="#fff"
                                        strokeMiterlimit="10"
                                        strokeWidth="2"
                                      />{" "}
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29005"
                                        data-name="Path 29005"
                                        d="M20.124,22.824h0c-2.277,0-4.124-2.362-4.124-4.639V16.124A4.124,4.124,0,0,1,20.124,12h0a4.124,4.124,0,0,1,4.124,4.124v2.062C24.247,20.463,22.4,22.824,20.124,22.824Z"
                                        transform="translate(-6.784 -4.846)"
                                        fill=""
                                        stroke="#fff"
                                        strokeLinecap="square"
                                        strokeMiterlimit="10"
                                        strokeWidth="2"
                                      />{" "}
                                      <circle
                                        data-v-bd82969a=""
                                        id="Ellipse_1365"
                                        data-name="Ellipse 1365"
                                        cx="11"
                                        cy="11"
                                        r="11"
                                        transform="translate(2.164 2.164)"
                                        fill="none"
                                        stroke="#fff"
                                        strokeLinecap="square"
                                        strokeMiterlimit="10"
                                        strokeWidth="2"
                                      />
                                    </g>
                                  </svg>
                                </span>{" "}
                                <span
                                  data-v-bd82969a=""
                                  className="font-14 txtProfile"
                                >
                                  {t("Profile")}
                                </span>
                              </div>
                            </a>
                          </li>
                        </>
                      )}
                      <li
                        data-v-bd82969a=""
                        className="settings pl-2 px-md-2 px-0"
                      >
                        <div
                          data-v-bd82969a=""
                          className="notification-dropdown"
                        >
                          <div
                            className={`notification-dropdown-button ${isMobile() ? "mobile" : ""
                              }`}
                            onClick={this.onChangeState("is_show_notification")}
                          >
                            <span className="notification-dropdown-button-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16.545"
                                height="18"
                                viewBox="0 0 16.545 18"
                                className="2"
                              >
                                <g id="bell" transform="translate(0.5 0.5)">
                                  <path
                                    id="Path_35098"
                                    data-name="Path 35098"
                                    d="M18.393,11.572A3.536,3.536,0,0,1,17.24,8.963V6.712A5.884,5.884,0,0,0,11.472,1,5.913,5.913,0,0,0,5.7,6.767v2.2a3.536,3.536,0,0,1-1.153,2.609A2.488,2.488,0,0,0,3.7,13.247c0,1.51,3.131,2.526,7.772,2.526s7.772-1.016,7.772-2.526A2.547,2.547,0,0,0,18.393,11.572Z"
                                    transform="translate(-3.7 -1)"
                                    fill="none"
                                    stroke="#fff"
                                    strokeWidth="1.5"
                                  />{" "}
                                  <path
                                    id="Path_35099"
                                    data-name="Path 35099"
                                    d="M25.619,56.51A22.364,22.364,0,0,1,23.2,56.4a2.491,2.491,0,0,0,2.419,1.787A2.524,2.524,0,0,0,28.038,56.4,22.364,22.364,0,0,1,25.619,56.51Z"
                                    transform="translate(-17.847 -41.187)"
                                    fill="#fff"
                                    stroke="#fff"
                                    strokeWidth="1"
                                  />
                                </g>
                              </svg>
                            </span>
                            {!isMobile() && (
                              <span className="notification-dropdown-button-text">
                                {t("Notification")}
                              </span>
                            )}
                            {un_read_count > 0 && (
                              <span className="notification-dropdown-button-number">
                                {un_read_count}
                              </span>
                            )}
                          </div>
                          {is_show_notification && (
                            <>
                              {
                                <div
                                  className="mask-close"
                                  onClick={this.onChangeState(
                                    "is_show_notification"
                                  )}
                                />
                              }
                              {
                                <div onClick={navigateTo("notification").bind(this)} className="notification-dropdown-body">
                                  <div className="notification-dropdown-header">
                                    <h3 className="notification-dropdown-title">
                                      {t("Notification")}
                                      <span
                                        onClick={this.onReadAllNotification}
                                        className="notification-dropdown-readall"
                                      >
                                        <span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="38"
                                            height="21"
                                            viewBox="0 0 38 21"
                                          >
                                            <g
                                              id="Group_21335"
                                              data-name="Group 21335"
                                              transform="translate(-917 -81)"
                                            >
                                              <rect
                                                id="Rectangle_4940"
                                                data-name="Rectangle 4940"
                                                width="38"
                                                height="21"
                                                rx="3"
                                                transform="translate(917 81)"
                                                fill="#878098"
                                              />{" "}
                                              <g
                                                id="check-all"
                                                transform="translate(924.785 83.931)"
                                              >
                                                <path
                                                  id="Path_35112"
                                                  data-name="Path 35112"
                                                  d="M4.773,18.9,0,14.123l1.3-1.3,3.91,2.607L14.336,5l1.3.652L6.757,18.727a1.3,1.3,0,0,1-1.985.168Z"
                                                  transform="translate(0 -5)"
                                                  fill="#fefefe"
                                                />{" "}
                                                <path
                                                  id="Path_35113"
                                                  data-name="Path 35113"
                                                  d="M28.91,10.3H25.652a.652.652,0,1,1,0-1.3H28.91a.652.652,0,1,1,0,1.3Z"
                                                  transform="translate(-8.709 -6.393)"
                                                  fill="#fefefe"
                                                />{" "}
                                                <path
                                                  id="Path_35114"
                                                  data-name="Path 35114"
                                                  d="M27.516,17.3H21.652a.652.652,0,0,1,0-1.3h5.865a.652.652,0,1,1,0,1.3Z"
                                                  transform="translate(-7.316 -8.832)"
                                                  fill="#fefefe"
                                                />{" "}
                                                <path
                                                  id="Path_35115"
                                                  data-name="Path 35115"
                                                  d="M25.774,24.3H16.652a.652.652,0,0,1,0-1.3h9.123a.652.652,0,0,1,0,1.3Z"
                                                  transform="translate(-5.574 -11.271)"
                                                  fill="#fefefe"
                                                />
                                              </g>
                                            </g>
                                          </svg>
                                        </span>{" "}
                                      </span>
                                    </h3>
                                    <span
                                      className="notification-dropdown-view-all"
                                      onClick={this.onViewAllNotification}
                                    >
                                      {t("ViewAll")}
                                    </span>
                                    <span onClick={this.onChangeState(
                                      "is_show_notification"
                                    )} className="notification-dropdown-close pe pe-7s-close" />
                                  </div>
                                  <div className="notification-dropdown-list">
                                    {notification && (
                                      <Notification list={notification} />
                                    )}
                                    {!notification && (
                                      <div className="notification-nodata">
                                        <span className="notification-dropdown-button-icon mb-3">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="21.899"
                                            height="23.949"
                                            viewBox="0 0 21.899 23.949"
                                            className="inline-block"
                                            role="none"
                                          >
                                            <g
                                              id="bell"
                                              transform="translate(-3.7 -1)"
                                              role="none"
                                            >
                                              <path
                                                id="Path_35098"
                                                data-name="Path 35098"
                                                d="M24.4,15.9a4.983,4.983,0,0,1-1.625-3.676V9.048A8.289,8.289,0,0,0,14.649,1,8.331,8.331,0,0,0,6.524,9.125v3.1A4.983,4.983,0,0,1,4.9,15.9a3.505,3.505,0,0,0-1.2,2.36c0,2.128,4.411,3.559,10.949,3.559S25.6,20.384,25.6,18.256A3.589,3.589,0,0,0,24.4,15.9Z"
                                                transform="translate(0 0)"
                                                fill="#878098"
                                                role="none"
                                              ></path>
                                              <path
                                                id="Path_35099"
                                                data-name="Path 35099"
                                                d="M26.6,56.555a31.474,31.474,0,0,1-3.4-.155,3.506,3.506,0,0,0,3.4,2.515,3.552,3.552,0,0,0,3.4-2.515A31.474,31.474,0,0,1,26.6,56.555Z"
                                                transform="translate(-11.955 -33.966)"
                                                fill="#878098"
                                                role="none"
                                              ></path>
                                            </g>
                                          </svg>
                                        </span>
                                        <p className="notification-nodata-note">
                                          {t("NoNewNotifications")}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              }
                            </>
                          )}
                        </div>
                      </li>
                      {isDesktop() &&
                        isCurrentRoute(constants.ROUTE.TRADING) && (
                          <li data-v-bd82969a="">
                            <span data-v-bd82969a="" className="line" />
                          </li>
                        )}

                      {/* <li data-v-bd82969a="" className="settings" ref={this.refList.is_show_helper}>
												<a data-v-bd82969a="" href="#" onClick={navigateTo('agency').bind(this)} className="buttonSetting d-block align-items-center pointer text-capitalize pc">
													<span data-v-bd82969a="" className="icon">
														<svg
															data-v-bd82969a="" xmlns="http://www.w3.org/2000/svg"
															width="17.281" height="17.283" viewBox="0 0 24 24"><g
																data-v-bd82969a="" id="circle-10"
																transform="translate(-1.164 -1.164)"><path
																	data-v-bd82969a="" id="Path_29003"
																	data-name="Path 29003"
																	d="M33.642,36.066V35.3a3.093,3.093,0,0,0-1.558-2.685l-3.078-1.765"
																	transform="translate(-13.086 -13.978)" fill="none"
																	stroke="#89809f" strokeMiterlimit="10"
																	strokeWidth="2" /> <path data-v-bd82969a=""
																		id="Path_29004"
																		data-name="Path 29004"
																		d="M14.636,30.847l-3.078,1.765A3.093,3.093,0,0,0,10,35.3v.768"
																		transform="translate(-3.876 -13.978)"
																		fill="none"
																		stroke="#89809f"
																		strokeMiterlimit="10"
																		strokeWidth="2" /> <path
																	data-v-bd82969a="" id="Path_29005"
																	data-name="Path 29005"
																	d="M20.124,22.824h0c-2.277,0-4.124-2.362-4.124-4.639V16.124A4.124,4.124,0,0,1,20.124,12h0a4.124,4.124,0,0,1,4.124,4.124v2.062C24.247,20.463,22.4,22.824,20.124,22.824Z"
																	transform="translate(-6.784 -4.846)" fill="none"
																	stroke="#89809f" strokeLinecap="square"
																	strokeMiterlimit="10" strokeWidth="2" /> <circle
																	data-v-bd82969a="" id="Ellipse_1365"
																	data-name="Ellipse 1365" cx="11" cy="11" r="11"
																	transform="translate(2.164 2.164)" fill="none"
																	stroke="#89809f" strokeLinecap="square"
																	strokeMiterlimit="10"
																	strokeWidth="2" /></g></svg>
													</span>
													<span data-v-bd82969a="">Đại lý</span>
												</a>
												{is_show_helper && <div className="notification-dropdown-body custom">
													<div className="notification-dropdown-header custom">
														<h3 className="notification-dropdown-title">
															<small>Liên hệ hotline: </small>
															<a className='notification-dropdown-phone' href={'tel:' + phone}>{phone}</a>
														</h3>
													</div>
												</div>}
											</li> */}
                      {/* <li data-v-bd82969a="" className="settings">
												<a data-v-bd82969a="" href="#" target="_blank" className="buttonSetting d-block align-items-center pointer text-capitalize pc">
													<span data-v-bd82969a="" className="icon">
														<svg data-v-bd82969a="" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 16.1 17.6" xmlSpace="preserve" width="17.281" height="17.281"><g data-v-bd82969a="" id="paper" transform="translate(-2.5 -0.5)"><g data-v-bd82969a="" id="Path_35096">
															<path data-v-bd82969a="" d="M16.2,18.1C16.2,18.1,16.2,18.1,16.2,18.1H4.9l0-1c0.1,0,1.4-0.2,1.4-1.4v-1.6h12.3v1.6    c0,0.6-0.2,1.2-0.7,1.7C17.4,17.9,16.8,18.1,16.2,18.1z M6.8,17.1h9.4h0c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1v-0.6H7.3v0.6    C7.3,16.3,7.1,16.8,6.8,17.1z" className="st0" /></g> <g
																data-v-bd82969a="" id="Path_35097"><path data-v-bd82969a="" d="M4.9,18.1c-1.3,0-2.4-1.1-2.4-2.4V0.5h13.8v12.3h-1V1.5H3.5v14.2c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0h1.6v1    H4.9C4.9,18.1,4.9,18.1,4.9,18.1z" className="st0" /></g> <g
																	data-v-bd82969a="" id="Line_1644"><rect data-v-bd82969a="" x="6.5" y="4.5" width="6" height="1" className="st0" /></g> <g
																		data-v-bd82969a="" id="Line_1645"><rect data-v-bd82969a="" x="6.5" y="7.5" width="6" height="1" className="st0" /></g> <g
																			data-v-bd82969a="" id="Line_1646"><rect data-v-bd82969a="" x="6.5" y="10.5" width="6" height="1" className="st0" /></g></g>
														</svg>
													</span>
													<span data-v-bd82969a="">Tin tức</span>
												</a>
											</li> */}

                      {isCurrentRoute(constants.ROUTE.TRADING) &&
                        isDesktop() && (
                          <li data-v-bd82969a="" className="settings">
                            <div
                              data-v-bd82969a=""
                              onClick={this.onToggle("is_show_transaction")}
                              className="buttonToggle pointer"
                            >
                              <svg
                                data-v-bd82969a=""
                                xmlns="http://www.w3.org/2000/svg"
                                width="3.331"
                                height="14.434"
                                viewBox="0 0 3.331 14.434"
                                className="iconClose"
                              >
                                <g
                                  data-v-bd82969a=""
                                  id="menu"
                                  transform="translate(0 -61)"
                                >
                                  <g
                                    data-v-bd82969a=""
                                    id="Group_13136"
                                    data-name="Group 13136"
                                    transform="translate(0 61)"
                                  >
                                    <g
                                      data-v-bd82969a=""
                                      id="Group_13135"
                                      data-name="Group 13135"
                                    >
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29631"
                                        data-name="Path 29631"
                                        d="M1.665,61a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,61Z"
                                        transform="translate(0 -61)"
                                        fill="#fff"
                                      />
                                    </g>
                                  </g>
                                  <g
                                    data-v-bd82969a=""
                                    id="Group_13138"
                                    data-name="Group 13138"
                                    transform="translate(0 66.551)"
                                  >
                                    <g
                                      data-v-bd82969a=""
                                      id="Group_13137"
                                      data-name="Group 13137"
                                    >
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29632"
                                        data-name="Path 29632"
                                        d="M1.665,211a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,211Z"
                                        transform="translate(0 -211)"
                                        fill="#fff"
                                      />
                                    </g>
                                  </g>
                                  <g
                                    data-v-bd82969a=""
                                    id="Group_13140"
                                    data-name="Group 13140"
                                    transform="translate(0 72.103)"
                                  >
                                    <g
                                      data-v-bd82969a=""
                                      id="Group_13139"
                                      data-name="Group 13139"
                                    >
                                      <path
                                        data-v-bd82969a=""
                                        id="Path_29633"
                                        data-name="Path 29633"
                                        d="M1.665,361a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,361Z"
                                        transform="translate(0 -361)"
                                        fill="#fff"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span
                                data-v-bd82969a=""
                                className="totalCount text-uppercase"
                                style={{
                                  display:
                                    total_bet_open > 0 ? "initial" : "none",
                                }}
                              >
                                {total_bet_open}
                              </span>
                            </div>
                          </li>
                        )}
                      {/* {isCurrentRoute(constants.ROUTE.TRADING) && isMobile() && <li data-v-bd82969a="">
												<div data-v-bd82969a="" className={setClassNameCondition(is_show_transaction, 'notification-dropdown--active', '', 'notification-dropdown mobile notification-transaction')}>
													<div className="notification-dropdown-button mobile" onClick={this.onToggle('is_show_transaction')}>
														<span className="notification-dropdown-button-icon">
															<svg data-v-bd82969a="" xmlns="http://www.w3.org/2000/svg" width="3.331" height="14.434" viewBox="0 0 3.331 14.434"
																className="iconClose">
																<g data-v-bd82969a="" id="menu" transform="translate(0 -61)"><g data-v-bd82969a=""
																	id="Group_13136"
																	data-name="Group 13136"
																	transform="translate(0 61)"><g
																		data-v-bd82969a="" id="Group_13135" data-name="Group 13135"><path data-v-bd82969a="" id="Path_29631"
																			data-name="Path 29631"
																			d="M1.665,61a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,61Z"
																			transform="translate(0 -61)"
																			fill="#fff" /></g></g><g data-v-bd82969a=""
																				id="Group_13138"
																				data-name="Group 13138"
																				transform="translate(0 66.551)"><g
																					data-v-bd82969a="" id="Group_13137" data-name="Group 13137"><path data-v-bd82969a="" id="Path_29632"
																						data-name="Path 29632"
																						d="M1.665,211a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,211Z"
																						transform="translate(0 -211)" fill="#fff" /></g></g><g
																							data-v-bd82969a="" id="Group_13140" data-name="Group 13140" transform="translate(0 72.103)"><g data-v-bd82969a=""
																								id="Group_13139"
																								data-name="Group 13139"><path
																				data-v-bd82969a="" id="Path_29633" data-name="Path 29633"
																				d="M1.665,361a1.665,1.665,0,1,0,1.665,1.665A1.667,1.667,0,0,0,1.665,361Z" transform="translate(0 -361)"
																				fill="#fff" /></g></g></g>
															</svg>
														</span>
														<span className="notification-dropdown-button-number" style={{ display: total_bet_open > 0 ? 'initial' : 'none' }}>{total_bet_open}</span>
													</div>
													{is_show_transaction && <>
														<div className="notification-dropdown-body">
															<div className="notification-dropdown-header">
																<h3 className="notification-dropdown-title">Giao dịch gần đây</h3>
																<span className="notification-dropdown-close pe pe-7s-close" onClick={this.onToggle('is_show_transaction')} />
															</div>
															<div className="notification-dropdown-list">
																<div data-v-5b2de64c="" className="flex-100 px-1">
																	<TransactionBox />
																</div>
															</div>
														</div>
														<div className="notification-dropdown-mask" onClick={this.onToggle('is_show_transaction')} />
													</>}
												</div>
											</li>} */}
                    </ul>
                  )
                ) : (
                  <>
                    <div
                      data-v-bd82969a=""
                      className={
                        "d-flex align-items-center gap-3 pr-2  " +
                        (isDesktop() ? "" : "groupAuthentication")
                      }
                    >
                      <a
                        data-v-bd82969a=""
                        href="#"
                        onClick={navigateTo('register').bind(this)}
                        className={`btnheader btn-register1 ${isDesktop() ? "" : "log-in"
                          } w-130px d-flex justify-content-center align-items-center`}
                      >
                        <span
                          data-v-bd82969a=""
                          className={
                            "font-16 text-capitalize  " +
                            (isDesktop() ? "" : "font-14m")
                          }
                          style={{ whiteSpace: "no-wrap" }}
                        >
                          {t("Register")}
                        </span>
                      </a>
                      <a
                        data-v-bd82969a=""
                        href="#"
                        onClick={navigateTo('login').bind(this)}
                        className={`btnheader w-130px ${isDesktop() ? "log-in" : "btn-register1"
                          } d-flex justify-content-center align-items-center`}
                      >
                        <span
                          data-v-bd82969a=""
                          className={
                            "font-16 text-capitalize " +
                            (isDesktop() ? "" : "font-14m")
                          }
                          style={{ whiteSpace: "no-wrap" }}
                        >
                          {t("Login")}
                        </span>
                      </a>
                    </div>
                  </>
                )}
                {/* {!login_token && isMobile() && <span data-v-bd82969a=""
								onClick={this.onToggle('is_show_login')}
								className={`mobileIcon ${is_show_login ? 'show' : 'hide'} mr-3`}>
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M19.875 7.12549H4.12501" stroke="#E5E6ED" stroke-width="2.25" stroke-miterlimit="10" stroke-linecap="round" />
									<path d="M19.875 12H10.125" stroke="#E5E6ED" stroke-width="2.25" stroke-miterlimit="10" stroke-linecap="round" />
									<path d="M19.875 16.874H7.125" stroke="#E5E6ED" stroke-width="2.25" stroke-miterlimit="10" stroke-linecap="round" />
								</svg>
							</span>} */}
              </div>
            </header>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    memberReducer: state.memberReducer,
    appReducer: state.appReducer,
    transactionReducer: state.transactionReducer,
    notificationReducer: state.notificationReducer,
    headerReducer: state.headerReducer,
  };
}
const withSnackbar = (Component) => (props) => {
  const { enqueueSnackbar } = useSnackbar();
  return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
  fetchingUser,
  fetchingUserSuccess,
  updateAppConfigAction,
  fetchingTransactionAction,
  fetchingNotification,
  closeBollinger,
})(withRouter(withTranslation()(withSnackbar(Header))));
